import React from "react";
import { useMsal } from "@azure/msal-react";
import { IconButton } from "@mui/material";
//import { makeStyles } from "@material-ui/core/styles";
import { IPublicClientApplication } from "@azure/msal-browser";
import LogoutIcon from '@mui/icons-material/Logout';
//import { Theme } from "@mui/material";

function handleLogout(instance: IPublicClientApplication) {
  
  localStorage.removeItem("IdToken");
  localStorage.removeItem("Token");
  localStorage.removeItem("Name");
  localStorage.removeItem("Surname");
  localStorage.removeItem("Role");
  
  instance.logoutRedirect().catch((e) => {
    console.error(e);
  });
}

/*const useStyles = makeStyles((theme: Theme) => ({
  iconButtonLabel: {
    display: 'flex',
    flexDirection: 'column',
  },
})); */

/**
 * Renders a button which, when selected, will redirect the page to the logout prompt
 */
export const SignOutButton = () => {

  const { instance } = useMsal();
  //const classes = useStyles()

  return (
    <IconButton /* classes={{label : classes.iconButtonLabel}} */ style={{ color: "white" }} onClick={() => handleLogout(instance)}>
      <LogoutIcon />
    </IconButton>
  );
};
